// Configuration files for the application

const warehouseCountry = import.meta.env.VITE_WAREHOUSE_COUNTRY || 'MX';

export const APP_CONFIG = {
  warehouseCountry,
  defaultCurrency: import.meta.env.VITE_DEFAULT_CURRENCY || 'mxn',
  appName: import.meta.env.VITE_APP_NAME || 'Beeping',
  /** URL del centro de ayuda. ES: beepinges.zendesk.com, MX/otros: beepingapp.zendesk.com */
  helpCenterUrl:
    warehouseCountry === 'ES' ? 'https://beepinges.zendesk.com/hc/es-es' : 'https://beepingapp.zendesk.com/',
  /** Clave del snippet Zendesk Web Widget. Misma región que el centro de ayuda (ES vs MX). */
  zendeskWidgetKey:
    warehouseCountry === 'ES' ? '9391b54a-d262-48cb-8f14-99404b95e426' : '06ec021c-4729-46d0-9885-b3b246dad0a5',
};
